import i18next from "i18next";
import { FC } from "react";
import { Profile } from "@/models/database/profiles/profile.model";
import { Avatar, Button, Flex, Spinner } from "@radix-ui/themes";

export const SettingsProfileImageButtons: FC<{
  imgSrc: string;
  profile: Profile;
  setIsSubmiting: any;
  submitProfileLogo: any;
  setIsAvatar: any;
  setImgSrc: any;
  isUpdating: boolean;
  setCroppedProfileImage: any;
  setOpenModal: any;
  submitImage: any;
}> = ({
  imgSrc,
  profile,
  setIsSubmiting,
  submitProfileLogo,
  setIsAvatar,
  setImgSrc,
  isUpdating,
  setCroppedProfileImage,
  setOpenModal,
  submitImage,
}) => {
  return (
    <Flex gap="3" wrap="wrap" direction="column" align="center">
      <Avatar
        src={imgSrc || profile.profileLogoUrl}
        fallback={profile.userName.slice(0, 1)}
        radius="full"
        size="9"
      />

      <Flex gap="3">
        {imgSrc && (
          <>
            <Button
              variant="solid"
              disabled={isUpdating}
              onClick={async () => {
                setIsSubmiting(true);
                await submitProfileLogo();
                setImgSrc(undefined);
                setCroppedProfileImage(undefined);
                setIsSubmiting(false);
                setOpenModal(false);
              }}
            >
              {isUpdating ? <Spinner /> : "Save changes"}
            </Button>

            <Button
              variant="outline"
              disabled={isUpdating}
              onClick={() => {
                setIsAvatar(false);
                setImgSrc(undefined);
                setCroppedProfileImage(undefined);
                setOpenModal(false);
              }}
            >
              Cancel
            </Button>
          </>
        )}

        {profile.profileLogoUrl && !imgSrc && (
          <Button
            variant="outline"
            onClick={async () => {
              setIsSubmiting(true);
              await submitImage();
              setImgSrc(undefined);
              setCroppedProfileImage(undefined);
              setOpenModal(false);
            }}
            disabled={isUpdating}
          >
            {isUpdating ? <Spinner /> : i18next.t("buttons.remove_avatar")}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
